import React from 'react';

const ModalUpsellBadge = ({product}) => {
  if (product.tags?.length === 0) {
    return;
  }

  return <div className="card__badge">
    {product.tags.includes('label: Gift with purchase') && <span className="badge badge-tm6">Gift with purchase</span>}
    {product.price.value > 0 && product.compareAtPriceMin.value > 0 && product.compareAtPriceMin.value > product.price.value && <span className="badge badge-sale">Sale</span>}
    {product.tags.includes('label: new') && <span className="badge badge-new">New</span>}
    {product.tags.includes('label: TM5') && <span className="badge badge-tm6">TM5</span>}
    {product.tags.includes('label: TM6') && <span className="badge badge-tm6">TM6</span>}
  </div>
};

export default ModalUpsellBadge;